import React, { Component } from 'react';
import {
    Button,
    Carousel,
    CarouselControl, CarouselIndicator, CarouselIndicators,
    CarouselInner,
    CarouselItem,
    Col,
    ListGroup,
    ListGroupItem,
    Row
} from "mdbreact";
// import { Carousel, CarouselCaption, CarouselControl, CarouselInner, CarouselItem, View, Mask, Button, Col, Row, ListGroup, ListGroupItem } from "mdbreact";


import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ReactPlayer from 'react-player';
import SameAds from "./sameads";
import { API_URL, IMAGE_URL } from "../../config/Config";
import axios from "axios/index";
import MerchantMap from "../../components/map/MerchantMap";
import { Breadcrumb, BreadcrumbItem, Container } from "reactstrap";
import { Link } from "react-router-dom";
import renderHTML from 'react-render-html';
import PageLoader from "../../components/loader/PageLoader";
import Search from "../../components/search/search"
import Products from "./products";
import ContactUser from "./contactuser";
import Comments from "./comments";

export default class MerchantItem extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.state = {
            activeItem: 0,
            maxLength: 1,
            merchant: {},
            categories: [],
            images: [],
            catName: '',
            lat: 35.739581,
            lng: 51.432568,
            name: '',
            loading: false,
            id: 0,
            tabItem: "1",
            tabvalue: 1,
            like: "block",
            unlike: "none",
            class: "",
            star_width: 1
        };
        this.starpoint = this.starpoint.bind(this);
        this.tabchange = this.tabchange.bind(this);
        this.like = this.like.bind(this);
        this.unlike = this.unlike.bind(this);
        // this.heart = this.heart.bind(this);
        // this.animate = this.animate.bind(this);
    }
    async componentDidMount() {
        const { params } = this.props.match;
        let id = await params.id;
        if (id) {
            this.setState({ id });
            await this.getBussinessObject();
        }
        this.setState({ loading: true });
    }
    async getBussinessObject() {

        let response = await axios.get(`${API_URL}business/${this.state.id}`);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            alert('خطایی در هنگام دریافت اطلاعات از سرور رخ داد.');

        } else {
            let merchant = response.data.data;
            let images = response.data.data.galleries;
            let categories = merchant.categories;
            let maxLength = images.length + 1;
            this.setState({ merchant, images, categories, maxLength });
        }
    }
    next() {
        let nextItem = this.state.activeItem + 1;
        if (nextItem >= this.state.maxLength) {
            this.setState({ activeItem: 0 });
        } else {
            this.setState({ activeItem: nextItem });
        }
    }

    prev() {
        let prevItem = this.state.activeItem - 1;
        if (prevItem < 0) {
            this.setState({ activeItem: this.state.maxLength - 1 });
        } else {
            this.setState({ activeItem: prevItem });
        }
    }

    goToIndex(item) {
        if (this.state.activeItem !== item) {
            this.setState({
                activeItem: item
            });
        }
    }

    mathrating(ratings) {
        const starTotal = 5;
        const starPercentage = (ratings / starTotal) * 100;
        var starPercentageRounded = `${(Math.round(starPercentage / 10) * 10)}%`;
        return starPercentageRounded
    }

    toggle(tab) {
        if (this.state.tabItem !== tab) {
            this.setState({
                tabItem: tab
            });
        }
    }
    tabchange(e, value) {
        this.setState({ tabvalue: value });
    }

    unlike() {
        this.setState({
            unlike: "none", like: "block"
        })
    }

    like() {
        this.setState({
            unlike: "block", like: "none"
        })
    }
    // heart(e) {
    //     console.log(this.state.class)
    //     var css = (this.state.class === ' is_animating alireza' ? "" : " is_animating alireza")
    //     this.setState({
    //         class: css
    //     })
    // }
    // animate() {
    //     console.log("animation")
    //     this.setState({
    //         class: " is_animating alireza"
    //     })
    // }
    starpoint(e) {
        // console.log(e.target.dataset.star);
        this.setState({ star_width: e.target.dataset.star })

    }

    render() {
        const { merchant, categories, images, activeItem } = this.state;
        // console.log(merchant);

        return (
            <div className="pt-3">
                {!this.state.loading ? <PageLoader type="bubbles" color="#4fbfa8" /> :
                    <Container>
                        <Breadcrumb className='w-100 white mt-3 rtl'>
                            <BreadcrumbItem><Link to="/">خانه</Link></BreadcrumbItem>
                            <BreadcrumbItem active>{merchant.title}</BreadcrumbItem>
                        </Breadcrumb>
                        <div className="Serach-box-inner">
                            <Search />
                        </div>

                        <div className="container rtl  white gallery-slideshow" style={{ minHeight: 500, marginTop: 20 }}>
                            <Row>
                                <Col>
                                    <Carousel
                                        thumbnails={false}
                                        activeItem={activeItem}
                                        next={this.next}
                                        className="gallery-carousel">
                                        <CarouselInner>
                                            <CarouselItem itemId="0">
                                                <img className="d-block w-100" src={IMAGE_URL + merchant.cover} alt={merchant.title} />
                                            </CarouselItem>
                                            {images.map((image, index) =>
                                                <CarouselItem itemId={index + 1} key={index}>
                                                    <img className="d-block w-100" src={IMAGE_URL + image.image_url} alt={image.image_title} />
                                                </CarouselItem>
                                            )}
                                        </CarouselInner>
                                        <CarouselControl direction="prev" role="button" onClick={() => { this.prev(); }} />
                                        <CarouselControl direction="next" role="button" onClick={() => { this.next(); }} />
                                        <CarouselIndicators>
                                            <CarouselIndicator img={IMAGE_URL + merchant.cover} active={activeItem === 0 ? true : false} onClick={() => { this.goToIndex(0); }}></CarouselIndicator>
                                            {images.map((image, index) =>
                                                <CarouselIndicator key={index} img={IMAGE_URL + image.image_url} active={activeItem === (index + 1) ? true : false} onClick={() => { this.goToIndex(index + 1); }}></CarouselIndicator>
                                            )}
                                        </CarouselIndicators>
                                    </Carousel>
                                    <div className="merchant-logo"><img src={IMAGE_URL + merchant.cover} alt={merchant.title} /></div>
                                </Col>
                            </Row>
                            <Row className=" merchant-desc">
                                <Col sm="12">
                                    <div className="merchant-star-title">
                                        <h1 className="teal-text">{merchant.title}</h1>
                                    </div>
                                    <div className="merchant-star-title">
                                        <div className="tb__cell">
                                            {/* <div className={"heart" + this.state.class} onClick={this.heart} onAnimationEnd={this.animate}></div> */}

                                            <Button className="btn-heart" onClick={this.unlike} style={{ display: this.state.unlike }}>
                                                <i className="far fa-heart" ></i>
                                            </Button>
                                            <Button className="btn-heart" onClick={this.like} style={{ display: this.state.like }}>
                                                <i className="fas fa-heart"></i>
                                            </Button>
                                        </div>
                                        <div className="tb_star">
                                            <div className="stars-outer">
                                                <div id="oneper" onClick={this.starpoint} data-star="1" ></div>
                                                <div id="twoper" onClick={this.starpoint} data-star="2"></div>
                                                <div id="threeper" onClick={this.starpoint} data-star="3"></div>
                                                <div id="fourper" onClick={this.starpoint} data-star="4"></div>
                                                <div id="fiveper" onClick={this.starpoint} data-star="5"></div>
                                                <div className="stars-inner"
                                                    style={{ width: this.mathrating(this.state.star_width) }}
                                                    id="stars"
                                                >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md="12" sm="12" className="white p-3 merchant-desc">
                                    <div className="merchant-short-des-address" >
                                        <p className="short-descrip">{merchant.short_desc}</p>
                                    </div>
                                    {/* <div className="merchant-short-des-address" >
                                        <p className="merchant-listing-address">
                                            <span className="listing-span">آدرس :</span>
                                            {merchant.address}
                                        </p>
                                        <p className="merchant-listing-address">
                                            <span className="listing-span">تلفن :</span>
                                            {merchant.phone}
                                        </p>
                                    </div> */}
                                </Col>
                                <Col xs='12'>
                                    <Tabs value={this.state.tabvalue} onChange={this.tabchange} className="information-tab" >
                                        <Tab label="اطلاعات" value={1} />
                                        <Tab label="محصولات" value={2} />
                                        <Tab label="تماس" value={3} />
                                        <Tab label="نظرات" value={4} />
                                    </Tabs>

                                    {this.state.tabvalue === 1 &&
                                        <div className="information-main">
                                            <div className="information-main-right" >
                                                <div className="text-justify md-6">
                                                    <h4 className="information-title">توضیحات</h4>
                                                    {renderHTML(merchant.description)}
                                                </div>
                                                <div className="video-player">
                                                    <h4 className="information-title">ویدیو</h4>
                                                    <div className='player-wrapper'>
                                                        <ReactPlayer
                                                            className='react-player'
                                                            url='https://home.wistia.com/medias/e4a27b971d'
                                                            width='100%'
                                                            height='100%'
                                                            controls={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="information-main-left">
                                                <div className="information-location" >
                                                    <h4 className="information-title">موقعیت</h4>
                                                    <MerchantMap lat={this.state.lat} lng={this.state.lng} name={this.state.name} />
                                                </div>
                                                <div className="information-address-phone">
                                                    <h4 className="information-title">مشخصات</h4>
                                                    <ListGroup className="list-flat">
                                                        <ListGroupItem><strong>شهر :</strong>{merchant.city.name}</ListGroupItem>
                                                        <ListGroupItem><strong>آدرس :</strong>{merchant.address}</ListGroupItem>
                                                        <ListGroupItem><strong>شماره تماس :</strong>{merchant.phone}</ListGroupItem>
                                                        <ListGroupItem><strong>وب سایت :</strong> <a href={merchant.website} target="_blank">{merchant.website}</a></ListGroupItem>
                                                        <ListGroupItem><strong>کدپستی :</strong>{merchant.postal_code}</ListGroupItem>
                                                    </ListGroup>
                                                </div>
                                                <div className="information-Possibilities-socials">
                                                    <h4 className="information-title">شبکه های اجتماعی</h4>
                                                    <ListGroup className="list-flat">
                                                        <ListGroupItem><strong>اینستاگرام :</strong>{merchant.instagram}</ListGroupItem>
                                                        <ListGroupItem><strong>تلگرام :</strong>{merchant.telegram}</ListGroupItem>
                                                        <ListGroupItem><strong>واتس آپ :</strong>{merchant.whatsapp}</ListGroupItem>
                                                        <ListGroupItem><strong>دسته :</strong> <Button className="btn-category">{categories[0].name}</Button> | <Button className="btn-category">{categories[1].name}</Button> </ListGroupItem>
                                                    </ListGroup>
                                                </div>
                                            </div>
                                            <div className="sameads">
                                                <SameAds />
                                            </div>
                                        </div>
                                    }
                                    {this.state.tabvalue === 2 &&
                                        <div>
                                            <Products />
                                        </div>
                                    }
                                    {this.state.tabvalue === 3 &&
                                        <div>
                                            <ContactUser />
                                        </div>
                                    }
                                    {this.state.tabvalue === 4 &&
                                        <div>
                                            <Comments />
                                        </div>
                                    }
                                </Col>

                            </Row>
                        </div>
                    </Container>
                }

            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/containers/merchants/MerchantItem.js